import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@pryme/ui/styles.css';
import './app.css';
import { App } from './App';
import { initEnvironments } from './lib/portal';

// Pick the environment (and its API base) before anything calls the API.
void initEnvironments().finally(() =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
);
